import Vue from 'vue';
import VueCookies from 'vue-cookies';

// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' , partitioned: false}
Vue.use(VueCookies);
